/* eslint-disable camelcase */
type Locale = 'en' | 'es';
type Phrase = (l: Locale) => string;

export const i18n_search_meditations: Phrase = locale => {
  const phrases: { [key: string]: undefined | string } = {
    en: `Search Meditations`,
    es: `Buscar meditaciones`,
  };
  return phrases[locale] || phrases.en || ``;
};
